var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 34,
    viewBox: "0 0 242 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1155_13524)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8206 11.481L83.9346 24.221L88.0486 11.481H92.4004L86.5508 28.4127H81.295L75.4688 11.481H79.8206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.805 28.4127H105.567V11.481H101.805V28.4127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.892 26.91C127.407 27.7163 126.691 28.3588 125.745 28.8384C124.799 29.3198 123.653 29.5596 122.307 29.5596C120.279 29.5596 118.609 29.0626 117.297 28.0669C115.983 27.0739 115.268 25.6836 115.149 23.8999H119.802C119.87 24.5863 120.113 25.1263 120.53 25.5198C120.948 25.9152 121.48 26.112 122.128 26.112C122.691 26.112 123.134 25.9582 123.458 25.6488C123.781 25.3404 123.943 24.9286 123.943 24.4142C123.943 23.952 123.794 23.5649 123.496 23.2555C123.197 22.948 122.827 22.6954 122.383 22.4977C121.94 22.3 121.327 22.0648 120.543 21.7903C119.401 21.3967 118.468 21.0151 117.744 20.6462C117.019 20.2774 116.398 19.7282 115.878 18.9979C115.358 18.2694 115.098 17.3221 115.098 16.1561C115.098 15.0761 115.37 14.1408 115.916 13.3528C116.461 12.5638 117.215 11.9589 118.179 11.5379C119.141 11.1178 120.245 10.9082 121.489 10.9082C123.5 10.9082 125.097 11.3887 126.282 12.3488C127.467 13.3098 128.136 14.6304 128.289 16.3108H123.559C123.475 15.7104 123.256 15.2345 122.908 14.883C122.558 14.5307 122.086 14.3559 121.489 14.3559C120.978 14.3559 120.564 14.4931 120.249 14.7668C119.933 15.0414 119.777 15.445 119.777 15.9758C119.777 16.4051 119.918 16.7702 120.198 17.0695C120.479 17.3706 120.832 17.615 121.259 17.8035C121.684 17.9911 122.299 18.2318 123.099 18.522C124.259 18.9174 125.204 19.3072 125.937 19.6944C126.669 20.0797 127.3 20.6407 127.829 21.3784C128.357 22.1161 128.621 23.0761 128.621 24.2595C128.621 25.2205 128.378 26.1037 127.892 26.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.952 16.4025C142.108 17.3378 141.687 18.6109 141.687 20.2235C141.687 21.8179 142.108 23.0882 142.952 24.03C143.795 24.9736 144.933 25.4449 146.365 25.4449C147.779 25.4449 148.912 24.9736 149.764 24.03C150.616 23.0882 151.042 21.8179 151.042 20.2235C151.042 18.6283 150.621 17.3589 149.777 16.4162C148.933 15.4735 147.795 15.0013 146.365 15.0013C144.933 15.0013 143.795 15.468 142.952 16.4025ZM151.003 12.1068C152.393 12.903 153.488 14.0105 154.289 15.4254C155.09 16.8403 155.491 18.4402 155.491 20.223C155.491 22.0068 155.086 23.6094 154.277 25.0335C153.468 26.4575 152.368 27.5677 150.978 28.3649C149.589 29.163 148.052 29.5611 146.365 29.5611C144.677 29.5611 143.139 29.163 141.75 28.3649C140.361 27.5677 139.262 26.4575 138.453 25.0335C137.643 23.6094 137.238 22.0068 137.238 20.223C137.238 18.4402 137.643 16.8403 138.453 15.4254C139.262 14.0105 140.361 12.903 141.75 12.1068C143.139 11.3087 144.677 10.9097 146.365 10.9097C148.068 10.9097 149.616 11.3087 151.003 12.1068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.916 21.8168V29.3802H165.102V11.2432H170.495C172.523 11.2432 174.036 11.7154 175.032 12.6581C176.029 13.6008 176.528 14.8968 176.528 16.5432C176.528 18.2236 176.012 19.5232 174.981 20.4403C173.95 21.3583 172.455 21.8168 170.495 21.8168H166.916ZM173.689 19.3082C174.37 18.6657 174.711 17.7432 174.711 16.5433C174.711 15.3087 174.37 14.3697 173.689 13.7253C173.007 13.0828 171.89 12.7616 170.34 12.7616H166.915V20.2729H170.34C171.89 20.2729 173.007 19.9516 173.689 19.3082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.905 27.9387H194.449V29.3802H186.09V11.2422H187.905V27.9387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.491 23.5122L209.938 13.7358L206.334 23.5122H213.491ZM214.028 24.9543H205.822L204.186 29.3785H202.27L208.915 11.6533H210.935L217.581 29.3785H215.639L214.028 24.9543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.306 29.3805H238.49L228.624 14.228V29.3805H226.809V11.269H228.624L238.49 26.4481V11.269H240.306V29.3805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7883 11.999L1.07031 33.5993H26.5053L13.7883 11.999Z",
    fill: "#004D95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7453 22.0964L17.0273 0.496094H42.4632L29.7453 22.0964Z",
    fill: "#20C1CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5226 11.999L33.8047 33.5993H59.2406L46.5226 11.999Z",
    fill: "#AA007B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1155_13524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 241.379,
    height: 33.1034,
    fill: "white",
    transform: "translate(0 0.496094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5a261074bb86b0275dab868b7e700909.svg";
export { ForwardRef as ReactComponent };